// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__f27Fq","breadcrumb":"Breadcrumbs_breadcrumb__5MX7l","name":"Breadcrumbs_name__wnPtR","connector":"Breadcrumbs_connector__QpcuB"};